import axios from 'axios';
import { API } from '../contexts/AuthContext';

export interface ExploreImage {
  id: string;
  imageUrl: string;
  sourceUrl?: string;
  title?: string;
  category: string;
  width?: number;
  height?: number;
  createdAt: string;
}

export interface ExploreFeedResult {
  items: ExploreImage[];
  nextCursor: string | null;
}

export async function getExploreFeed(params: {
  limit?: number;
  cursor?: string;
  category?: string;
}): Promise<ExploreFeedResult> {
  const { data } = await axios.get<ExploreFeedResult>(`${API}/explore`, {
    params: {
      ...(params.limit    !== undefined ? { limit:    params.limit    } : {}),
      ...(params.cursor   !== undefined ? { cursor:   params.cursor   } : {}),
      ...(params.category !== undefined ? { category: params.category } : {}),
    },
  });
  return data;
}
